<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      spreadCode: this.$route.params.spreadCode
    };
  },
  created() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      this.axios({
        method: "get",
        url: "/mall/api/spread/detail/code",
        params: {
          code: this.spreadCode
        }
      }).then(res => {
        if (res.data.code == 200 && res.data.data) {
          if (this.$route.fullPath.split("?").length == 1) {
            this.$router.replace(res.data.data.redirectUrl);
          } else if (this.$route.fullPath.split("?").length == 2) {
            if (res.data.data.redirectUrl.indexOf("?") != -1) {
              this.$router.replace(
                `${res.data.data.redirectUrl}&${
                  this.$route.fullPath.split("?")[1]
                }`
              );
            } else {
              this.$router.replace(
                `${res.data.data.redirectUrl}?${
                  this.$route.fullPath.split("?")[1]
                }`
              );
            }
          }
        } else {
          this.$router.replace("/index");
        }
      });
    }
  }
};
</script>
